@if (backRouterLink && backRouterLinkLabel) {
  <div class="top-header">
    @if (currentLabel) {
      <nav class="top-header__trail" [attr.aria-label]="'TRANS__TOP_HEADER__BREADCRUMBS' | translate">
        <ng-container *ngTemplateOutlet="goBack"></ng-container>
        <span class="top-header__current" aria-current="page">
          <mat-icon aria-hidden="true">navigate_next</mat-icon>
          {{ currentLabel | translate }}
        </span>
      </nav>
    } @else {
      <ng-container *ngTemplateOutlet="goBack"></ng-container>
    }
  </div>
}

<ng-template #goBack>
  <a mat-button
     [routerLink]="backRouterLink"
     [queryParams]="queryParams"
     [queryParamsHandling]="queryParamsHandling"
     class="top-header__go-back text-primary-hover"
  >
    <mat-icon>
      navigate_before
    </mat-icon>

    {{ backRouterLinkLabel | translate }}
  </a>
</ng-template>
